import React from "react"
import styled from "styled-components"

import signet from "../images/logos/solaris-signet.svg"

const SignetEl = styled.div`
  height: 70px;
  width: 70px;

  img {
    height: 100%;
    width: 100%;
  }
`

const Signet = ({ className }) => {
  return (
    <SignetEl className={className}>
      <img src={signet} alt="" width="70" height="70" />
    </SignetEl>
  )
}

export default Signet
